var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('img',{staticClass:"imagePreloader_components",style:({ content: _vm.content }),attrs:{"id":_vm.id}})])
}
var staticRenderFns = []

export { render, staticRenderFns }